import { BehaviorSubject }  from 'rxjs';
import {
	Component,
	EventEmitter,
	Output
}        										from '@angular/core';
import {
	ConfigService,
	MapLegend,
	MapService,
	StateService
}									          from '../../';

export interface LegendConfigProtocol {
  color: string;
} 

export class LegendInput {
  constructor(
    public close:   () => void,
    public config:  BehaviorSubject<LegendConfigProtocol>,
    public symbols: BehaviorSubject<MapLegend[]>
  ) {}
}

@Component({
  selector:			'electra-legend',
  styleUrls:		[ './legend.component.scss' ],
  templateUrl:	'./legend.component.html'
})
export class LegendComponent {
	config: LegendConfigProtocol;
	legend: MapLegend[];

	slideTop = 0;

	@Output() update	= new EventEmitter<number>();

  constructor(public configService: ConfigService, public mapService: MapService, public stateService: StateService) {
		configService.legend.subscribe(data => { this.gotConfig(data) });
		mapService.legend.subscribe(data => { this.gotLegend(data) });
	}

  closeClick() {
    setTimeout( () => {
        this.stateService.state = 'map';
   }, 5);
  }

	getEntryStyle(i: number): any {
		return this.configService.mobile ? {
			left: (Math.floor(i / 2) * 100) + 'px',
			top: (i % 2 * 68) + 'px'
    } : {
			top: (i * 50 + 8) + 'px'
		};
	}

	getEntrySubStyle(p: string): string {
		return p.length === 0 ? 'hide' : '';
	}

	gotConfig(config: LegendConfigProtocol) {
		this.config = config;
	}

	gotLegend(legend: MapLegend[]) {
		this.legend = legend;
	}

	updateY(event: number) {
		if (event < 1) {
			this.slideTop = event * -1;
		} else {
			this.slideTop = 0;
		}

		this.update.next(this.slideTop);
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/legend/legend.component.ts